import SkuSelectorProvider from './hooks/useSkuSelector';

import { SkuSelectorProps } from './@types/SkuSelectorProps';
import SkuSelectorContainer from './handles/SkuSelectorContainer';
import SkuSelectorSubContainer from './handles/SkuSelectorSubContainer';
import TextContainer from './handles/TextContainer';
import OptionsList from './handles/OptionsList';
import SkuSelectorItem from './handles/SkuSelectorItem';
import SkuSizeSelectorItem from './handles/SkuSizeSelectorItem';
import ValueWrapper from './handles/ValueWrapper';
import SelectorItemImageValue from './handles/SelectorItemImageValue';

import './SkuSelector.scss';

const SkuSelector = (props: SkuSelectorProps) => {
	return (
		<SkuSelectorProvider {...props}>
			<SkuSelectorContainer>
				<SkuSelectorSubContainer type="tamanho">
					{props.showVariationsLabels ? <TextContainer type="Tamanho" /> : null}
					<OptionsList>
						<SkuSizeSelectorItem value="p">
							<ValueWrapper additionalClasses={'c-on-base center pl5 pr5 z-1 t-body'}>P</ValueWrapper>
						</SkuSizeSelectorItem>
						<SkuSizeSelectorItem value="m">
							<ValueWrapper additionalClasses={'c-on-base center pl5 pr5 z-1 t-body'}>M</ValueWrapper>
						</SkuSizeSelectorItem>
						<SkuSizeSelectorItem value="g">
							<ValueWrapper additionalClasses={'c-on-base center pl5 pr5 z-1 t-body'}>G</ValueWrapper>
						</SkuSizeSelectorItem>
					</OptionsList>
				</SkuSelectorSubContainer>
				<SkuSelectorSubContainer type="cor">
					{props.showVariationsLabels ? <TextContainer type="Cor" /> : null}
					<OptionsList>
						<SkuSelectorItem value="rosa">
							<ValueWrapper additionalClasses={'h-100'}>
								<SelectorItemImageValue value={'ee64bc'} />
							</ValueWrapper>
						</SkuSelectorItem>
						<SkuSelectorItem value="azul">
							<ValueWrapper additionalClasses={'h-100'}>
								<SelectorItemImageValue value={'4287f5'} />
							</ValueWrapper>
						</SkuSelectorItem>
						<SkuSelectorItem value="verde">
							<ValueWrapper additionalClasses={'h-100'}>
								<SelectorItemImageValue value={'e3b52b'} />
							</ValueWrapper>
						</SkuSelectorItem>
						<SkuSelectorItem value="vermelho">
							<ValueWrapper additionalClasses={'h-100'}>
								<SelectorItemImageValue value={'1f0330'} />
							</ValueWrapper>
						</SkuSelectorItem>
					</OptionsList>
				</SkuSelectorSubContainer>
			</SkuSelectorContainer>
		</SkuSelectorProvider>
	);
};

export default SkuSelector;
